import "./App.css";
import Footer from "./components/Footer/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./components/Footer/Footer.css";
import Home from "./components/Home/Home";
import SignIn from "./components/Auth/SignIn";
import SignUp from "./components/Auth/SignUp";
import Error404 from "./components/404";
import MyNavbar from "./components/Navbar/Navbar";
import Products from "./components/Products/Products";
import Cart from "./components/Navbar/Cart/Cart";
import Profile from "./components/Auth/Profile";
import VerifyEmailAfterSignUp from "./components/Auth/VerifyEmailAfterSignUp";
import { useEffect, useState } from "react";
import { auth, db } from "./firebase-config";
import { getDocs, collection } from "firebase/firestore";
import SendResetPasswordEmail from "./components/Auth/ResetPassword/SendResetPasswordEmail";
import ResetPassword from "./components/Auth/ResetPassword/ResetPassword";
import ResetRedirect from "./components/Auth/ResetPassword/ResetRedirect";
import ContactUs from "./components/Footer/Static/ContactUs";

function App() {
  const [userId, setUserId] = useState(false);
  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (auth.currentUser) {
        setUserId(true);
        const collectionRef = collection(db, auth.currentUser.uid);
        const getProducts = async () => {
          const data = await getDocs(collectionRef);
          // console.log(auth.currentUser.uid);
        };
        getProducts();
      }
    });
  }, []);
  return (
    <>
      <MyNavbar />
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/Home" element={<Home />} />
          <Route exact path="/Products" element={<Products />} />

          <Route exact path="/SignUp" element={<SignUp />} />
          <Route exact path="/SignIn" element={<SignIn />} />

          {/* <Route exact path="/Cart" element={<Cart />} />
          <Route exact path="/Profile" element={<Profile />} /> */}
          <Route
            exact
            path="/VerifyEmail"
            element={<VerifyEmailAfterSignUp />}
          />
          <Route exact path="/ResetMailSent" element={<ResetRedirect />} />
          <Route
            exact
            path="/SendResetEmail"
            element={<SendResetPasswordEmail />}
          />

          <Route exact path="/ResetPassword" element={<ResetPassword />} />
          <Route exact path="/ContactUs" element={<ContactUs />} />

          <Route exact path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
